import * as ACTIONS from 'constant/actions/error-statistics'
import initialState from './initial-state'
import { v4 as uuid } from 'uuid'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.ERROR_STATISTICS_SHOW_MODAL:
      state = {
        ...state,
        modalContent: action.modalContent,
        modalShowing: true,
      };
      break;
    case ACTIONS.ERROR_STATISTICS_HIDE_MODAL:
      state = {
        ...state,
        modalContent: undefined,
        modalShowing: false,
      };
      break;
    case ACTIONS.ERROR_STATISTICS_GET_LATEST + "_PENDING":
      state = {
        ...state,
        errorStatisticsLoading: true,
      };
      break;
    case ACTIONS.ERROR_STATISTICS_GET_LATEST + "_FULFILLED":
      const errorTypes = action.payload.data.errorExceptionTypes.reduce((obj = {}, errorType) => {
        obj[errorType.EEMN] = errorType;
        return obj;
      }, {});

      state = {
        ...state,
        errorStatisticsLoading: false,
        errorStats: action.payload.data.errorStats,
        errorExceptionTypes: errorTypes || {},
      };
      break;
    case ACTIONS.ERROR_STATISTICS_GET_KPIS + "_PENDING":
      state = {
        ...state,
        errorKpisLoading: true,
      };
      break;
    case ACTIONS.ERROR_STATISTICS_GET_KPIS + "_FULFILLED":
      state = {
        ...state,
        errorKpisLoading: false,
        errorStatisticsKpis: action.payload.data.kpis,
      };
      break;
    case ACTIONS.ERROR_SET_ERROR_TAB:
      state = {
        ...state,
        errorTab: action.payload,
      };
      break;
    case ACTIONS.ERROR_GET_ERROR_BY_DATE + "_PENDING":
      state = {
        ...state,
        errorKpisLoading: true,
      };
      break;
    case ACTIONS.ERROR_GET_ERROR_BY_DATE + "_FULFILLED":
      console.log(action.payload, "payload");
      state = {
        ...state,
        errorKpisLoading: false,
        errorStats: action.payload.data.errorStats,
        errorStatisticsKpis: action.payload.data.kpis,
      };
      break;
  }

  return state
}
